import { useState } from 'react';
import { buildIntegrationPrompt } from '../lib/integrationPrompt';

/**
 * Copies the prototype-factory API reference as a ready-to-paste prompt for
 * the AI coding tool that builds the external site. Holds no token.
 */
export function CopyIntegrationPromptButton({ className = 'btn-secondary' }: { className?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className={`${className} whitespace-nowrap`}
      onClick={() => {
        void navigator.clipboard?.writeText(buildIntegrationPrompt(window.location.origin));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }}
    >
      {copied ? 'Copied' : 'Copy integration prompt'}
    </button>
  );
}
